ht.declare('a.moreInfo', function () {
  var opts = $(this).metadata().quickviewOpts;
  $(this).quickview(opts);
});
